import { safeDefine } from "../../registration/safe-define.js";
import { NeutralLiveAudioSkinElement } from "../../presets/live-audio/neutral-skin.js";
import "../../internal/skins/neutral-live-audio/register.js";
//#region src/define/live-audio/neutral-skin.ts
safeDefine(NeutralLiveAudioSkinElement);
//#endregion

//# sourceMappingURL=neutral-skin.js.map